import { useParams } from '@tanstack/react-router';

export function useOwnerIdQueryPayload() {
    const params = useParams({ strict: false });
    return params.ownerId ? { enterpriseId: params.ownerId } : {};
}
